import { render, staticRenderFns } from "./InfoIcon.vue?vue&type=template&id=6d0a25be&scoped=true"
import script from "./InfoIcon.vue?vue&type=script&lang=ts"
export * from "./InfoIcon.vue?vue&type=script&lang=ts"
import style0 from "./InfoIcon.vue?vue&type=style&index=0&id=6d0a25be&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0a25be",
  null
  
)

export default component.exports